import { render, staticRenderFns } from "./ConsultationBubble.vue?vue&type=template&id=115c56c2&scoped=true"
import script from "./ConsultationBubble.vue?vue&type=script&lang=js"
export * from "./ConsultationBubble.vue?vue&type=script&lang=js"
import style0 from "./ConsultationBubble.vue?vue&type=style&index=0&id=115c56c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c56c2",
  null
  
)

export default component.exports